import { render, staticRenderFns } from "./ServiceDashboardLiveTutorCard.vue?vue&type=template&id=bd25f670&scoped=true&"
import script from "./ServiceDashboardLiveTutorCard.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardLiveTutorCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardLiveTutorCard.vue?vue&type=style&index=0&id=bd25f670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd25f670",
  null
  
)

export default component.exports